import survey from './survey'
import question from './question'
import answer from './answer'

export default {
  name: 'Questionnaire',
  path: 'questionnaire',
  meta: {
    label: 'questionnaire',
    auth: 'questionnaire'
  },
  component: {
    name: 'Questionnaire',
    render(c) {
      return c('router-view')
    }
  },
  children: [survey, question, answer]
}
